import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { useForm } from "react-hook-form";

const JoiOption = Joi.object({
  label: Joi.string(),
  value: Joi.string(),
  checked: Joi.any(),
});

const printSchema = Joi.object({
  transferDate: Joi.date().required().messages({ "any.required": "Harap mengisi Tanggal transfer" }),
  codeType: JoiOption.required().messages({ "any.required": "Harap mengisi Tipe user" }),
  area: JoiOption.required().messages({ "any.required": "Harap mengisi Wilayah" }),
  pool: JoiOption.required().messages({ "any.required": "Harap mengisi Pool" }),
  company: JoiOption.required().messages({ "any.required": "Harap mengisi Perusahaan" }),
  hasRelation: Joi.boolean(),
  companyRelation: Joi.any(),
  segment: JoiOption.required().messages({ "any.required": "Harap mengisi Segment" }),
});

const usePrintHook = () => {
  const printMethods = useForm({
    resolver: joiResolver(printSchema),
  });

  return {
    printMethods,
  };
};

export default usePrintHook;
